// Texts of the percentile trends: a point's text is shared by the Percentiles chart's hover and the percentile items panel's title
import moment from 'moment';
import pluralize from 'pluralize';

import { formatDateSpan } from './dates';

const TITLE_FORMATS = { month: 'MMMM YYYY', quarter: '[Q]Q YYYY' };
const TICK_FORMATS = { week: 'D MMM', month: 'MMM', quarter: '[Q]Q' };

export function percentileGroupText({ by, period, periodStart, first, last, count, incomplete }) {
  const items = pluralize('completed item', count, true);
  const span = formatDateSpan(moment(first), moment(last));

  if (by === 'items') {
    return { title: items, aboveRows: [`Completed ${span}`], belowRows: [] };
  }

  return {
    title: incomplete || period === 'week' ? span : moment(periodStart).format(TITLE_FORMATS[period]),
    aboveRows: [items],
    belowRows: incomplete ? [`Incomplete ${period}`] : []
  };
}

export function percentileTickLabel(tick, period) {
  return moment(tick.date).format(TICK_FORMATS[period]);
}
